/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../cardr/issuing/model';
import '../../bizbank/card';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "SetCardStateForMerchantRequest": {
                "fields": {
                  "merchantToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "cardToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "newState": {
                    "type": ".squareup.cardr.issuing.CardState",
                    "id": 3,
                    "rule": "optional"
                  },
                  "cardStatus": {
                    "type": ".squareup.bizbank.cards.CardStatus",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "SetCardStateForMerchantResponse": {
                "fields": {
                  "newState": {
                    "type": ".squareup.cardr.issuing.CardState",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "cardStatus": {
                    "type": ".squareup.bizbank.cards.CardStatus",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.SetCardStateForMerchantRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.SetCardStateForMerchantResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE SetCardStateForMerchantRequest @ squareup/corporate_card/service/set_card_state_for_merchant.proto at 11:1
 */
export const SetCardStateForMerchantRequest = $root.lookupType('squareup.corporate_card.service.SetCardStateForMerchantRequest');
fixType(SetCardStateForMerchantRequest, {
  merchantToken: {
    required: true
  },
  cardToken: {
    required: true
  }
});
Builder.createAndAttachToType(SetCardStateForMerchantRequest);
/**
 * SOURCE SetCardStateForMerchantResponse @ squareup/corporate_card/service/set_card_state_for_merchant.proto at 34:1
 */
export const SetCardStateForMerchantResponse = $root.lookupType('squareup.corporate_card.service.SetCardStateForMerchantResponse');
fixType(SetCardStateForMerchantResponse);
Builder.createAndAttachToType(SetCardStateForMerchantResponse);